import { render, staticRenderFns } from "./Gw.vue?vue&type=template&id=37cb91f6&scoped=true"
import script from "./Gw.vue?vue&type=script&lang=js"
export * from "./Gw.vue?vue&type=script&lang=js"
import style0 from "./Gw.vue?vue&type=style&index=0&id=37cb91f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb91f6",
  null
  
)

export default component.exports